import { useAppDispatch } from "@/shared/lib/redux"
import { IUser } from "@/shared/api/users"
import { openUserDeleteRestoreModal as openAction, UserDeleteRestoreMode } from "../../model"

export const useUserDeleteRestoreModal = () => {
    const dispatch = useAppDispatch()

    const openUserDeleteRestoreModal = (user: IUser, mode: UserDeleteRestoreMode, onSuccess?: () => void) => {
        dispatch(openAction({ user, mode, onSuccess }))
    }

    return { openUserDeleteRestoreModal }
}
